import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DeviceService } from './device.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadBaseetaService {

  constructor(private deviceService : DeviceService) { }

  downloadApp(){
    const userAgent = window.navigator.userAgent; 
    if (/iPad|iPhone/.test(userAgent))
      window.open( environment.baseetaIOS, '_blank');
    else if (this.deviceService.isAndroid(userAgent))
      window.open(environment.baseetaAndroid, '_blank');
  }

}
